import React, { useState } from 'react';
import './Tooltip.css'; // Make sure to import the CSS for styling

const Tooltip = () => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div className="tooltip-container">
            <div
                className="question-mark-circle"
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
            >
                ?
            </div>
            {isVisible && (
                <div className="tooltip-box">
                    Not uploading a file will exclude this page from the PDF.
                </div>
            )}
        </div>
    );
};

export default Tooltip;